
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecde6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecde6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("14CJr", function(module, exports) {

$parcel$export(module.exports, "getOtpFormDom", function () { return $b3237b5a14e1adc9$export$7e70035133f4e33b; });
$parcel$export(module.exports, "wireOtpCodeForm", function () { return $b3237b5a14e1adc9$export$6af48c960b4f24f0; });
/**
 * The code form inside the "check your email" panel, shared by /login/ and
 * /register/ (#54).
 *
 * The resend is identical on both pages: `signInWithOtp` with
 * `shouldCreateUser: false`. On /register/ that is safe because the panel
 * only ever appears after `/api/register` has already answered 200, so the
 * account already exists by the time a resend can be clicked -- there is
 * nothing left for `shouldCreateUser: false` to refuse. Everything else is
 * identical by requirement too, including the error wording: both panels
 * appear whether or not the address has an account, so a message that varied
 * would answer through the back door the question the panels refuse to
 * answer at the front.
 */ 
var $5DLox = parcelRequire("5DLox");

var $SPzs2 = parcelRequire("SPzs2");

var $hmghX = parcelRequire("hmghX");

var $8C6MA = parcelRequire("8C6MA");

var $5nYF6 = parcelRequire("5nYF6");
function $b3237b5a14e1adc9$export$7e70035133f4e33b() {
    return {
        form: document.getElementById("codeForm"),
        input: document.getElementById("codeInput"),
        submit: document.getElementById("codeSubmit"),
        resend: document.getElementById("resendButton"),
        status: document.getElementById("codeStatus")
    };
}
/** Clears both places a previous attempt could have left a message. */ function $b3237b5a14e1adc9$var$clearFormMessages(dom) {
    (0, $8C6MA.clearFormError)(dom.form);
    dom.status.textContent = "";
}
/**
 * `sentAt` is when the mail went out, not when the panel was drawn by some
 * other route: GoTrue's minimum interval between two mails to one address runs
 * from the send, so a countdown started on the click would offer a resend the
 * server still refuses with 429.
 */ function $b3237b5a14e1adc9$var$startCountdown(dom, sentAt) {
    const tick = ()=>{
        const left = (0, $SPzs2.resendSecondsLeft)(sentAt, Date.now());
        dom.resend.disabled = left > 0;
        dom.resend.textContent = left > 0 ? `Resend code in ${(0, $SPzs2.formatCountdown)(left)}` : "Resend code";
        if (left > 0) window.setTimeout(tick, 1000);
    };
    tick();
}
async function $b3237b5a14e1adc9$var$submitCode(dom, email) {
    $b3237b5a14e1adc9$var$clearFormMessages(dom);
    (0, $5nYF6.setButtonBusy)(dom.submit, true);
    const result = await (0, $SPzs2.runOtpCodeSignIn)({
        email: email,
        token: dom.input.value,
        verifyOtp: async (args)=>{
            const { data: data, error: error } = await (0, $5DLox.supabase).auth.verifyOtp(args);
            return {
                session: data.session,
                error: error
            };
        },
        completeRegistration: (0, $hmghX.postCompleteRegistration)
    });
    if (result.ok) {
        window.location.href = result.target;
        return;
    }
    // One wording for every failure: GoTrue answers wrong, expired, spent and
    // never-existed alike with the same 403. The detail goes to the console.
    (0, $8C6MA.showFormError)(dom.form, "That code didn't work. Check it, or request a new one.", result.detail);
    (0, $5nYF6.setButtonBusy)(dom.submit, false);
    // A failed verify does not consume the token, so leave it there to correct.
    dom.input.focus();
    dom.input.select();
}
function $b3237b5a14e1adc9$export$6af48c960b4f24f0(opts) {
    const { dom: dom, email: email, sentAt: sentAt } = opts;
    $b3237b5a14e1adc9$var$startCountdown(dom, sentAt);
    // `dom.submit.disabled` (set inside `submitCode`) only blocks the button --
    // it does nothing against a scripted `form.requestSubmit()`. Without this
    // guard, a failed verify refocuses+selects the input (by requirement, so the
    // code stays correctable), and pasting a fresh 6-digit code while the first
    // `verifyOtp` is still pending would start a second `submitCode` concurrently.
    // Plain closure state is enough: this form has one input in flight at a time.
    let inFlight = false;
    const startSubmit = ()=>{
        if (inFlight) return;
        inFlight = true;
        $b3237b5a14e1adc9$var$submitCode(dom, email).finally(()=>{
            inFlight = false;
        });
    };
    dom.input.addEventListener("input", ()=>{
        // Digits only, so a pasted "123 456" or "code: 123456" still works.
        dom.input.value = dom.input.value.replace(/\D/g, "").slice(0, (0, $SPzs2.OTP_CODE_LENGTH));
        // A busy button stays disabled until its verify answers.
        if (!(0, $5nYF6.isButtonBusy)(dom.submit)) dom.submit.disabled = dom.input.value.length !== (0, $SPzs2.OTP_CODE_LENGTH);
        if (dom.input.value.length === (0, $SPzs2.OTP_CODE_LENGTH)) dom.form.requestSubmit();
    });
    dom.form.addEventListener("submit", (event)=>{
        event.preventDefault();
        startSubmit();
    });
    dom.resend.addEventListener("click", ()=>{
        // A resend while a verify is still pending would clear the input and
        // disable submit out from under it; the pending failure branch would then
        // re-enable submit over an empty field, so a click would report
        // `reason: "empty"` as "That code didn't work." Sharing the submit path's
        // guard keeps a resend from starting mid-verify.
        if (inFlight) return;
        (async ()=>{
            $b3237b5a14e1adc9$var$clearFormMessages(dom);
            dom.resend.disabled = true;
            // Silent for the same reason the first send is: an address without an
            // account is an expected outcome of this form, not a fault, and the
            // outcome must not distinguish the two -- so a resend failure is
            // reported the same way for every address, like the first send.
            const { error: error } = await (0, $5DLox.supabase).auth.signInWithOtp({
                email: email,
                options: {
                    shouldCreateUser: false
                }
            });
            if (error) console.info("code not resent", error);
            dom.status.textContent = "New code sent.";
            dom.input.value = "";
            dom.submit.disabled = true;
            $b3237b5a14e1adc9$var$startCountdown(dom, Date.now());
        })();
    });
}

});
parcelRegister("SPzs2", function(module, exports) {

$parcel$export(module.exports, "OTP_CODE_LENGTH", function () { return $c6762c78af8722d5$export$1ed04e6157eef4d5; });
$parcel$export(module.exports, "runOtpCodeSignIn", function () { return $c6762c78af8722d5$export$eb1a3664102c562; });
$parcel$export(module.exports, "resendSecondsLeft", function () { return $c6762c78af8722d5$export$e0606446bf4cccf; });
$parcel$export(module.exports, "formatCountdown", function () { return $c6762c78af8722d5$export$4f0eff23342a9a3b; });
/**
 * Signing in with the code from the email, separated from the pages so it can
 * be tested (#54, following the shape #320 gave `auth-callback-lib.ts`).
 *
 * This returns a decision instead of performing it: navigation, DOM and logging
 * stay in `login.ts` / `register.ts`; everything worth asserting is here.
 */ /** `mailer_otp_length` in the production Auth config. */ const $c6762c78af8722d5$export$1ed04e6157eef4d5 = 6;
const $c6762c78af8722d5$export$eba9875212d85d67 = 60;
function $c6762c78af8722d5$var$messageOf(error) {
    if (error === null || error === undefined) return null;
    if (error instanceof Error) return error.message;
    return typeof error === "string" ? error : JSON.stringify(error);
}
async function $c6762c78af8722d5$export$eb1a3664102c562(deps) {
    const { email: email, verifyOtp: verifyOtp, completeRegistration: completeRegistration } = deps;
    const token = deps.token.trim();
    if (token.length !== $c6762c78af8722d5$export$1ed04e6157eef4d5) return {
        ok: false,
        reason: "empty",
        detail: null
    };
    try {
        const { session: session, error: error } = await verifyOtp({
            email: email,
            token: token,
            type: "email"
        });
        if (error !== null || session === null) return {
            ok: false,
            reason: "verify",
            detail: $c6762c78af8722d5$var$messageOf(error)
        };
        const onboarded = session.user.user_metadata.onboarded === true;
        if (!onboarded) // Best-effort, and deliberately awaited: /app/ renders the persisted name
        // on boot, so this has to finish first. A failure here must not strand a
        // user who is already signed in.
        try {
            await completeRegistration(session.access_token);
        } catch (err) {
            console.error("complete-registration failed", err);
        }
        return {
            ok: true,
            target: onboarded ? "/app/" : "/app/?welcome=1"
        };
    } catch (err) {
        return {
            ok: false,
            reason: "threw",
            detail: $c6762c78af8722d5$var$messageOf(err)
        };
    }
}
function $c6762c78af8722d5$export$e0606446bf4cccf(lastSentAt, now) {
    const elapsed = Math.floor((now - lastSentAt) / 1000);
    return Math.max(0, $c6762c78af8722d5$export$eba9875212d85d67 - elapsed);
}
function $c6762c78af8722d5$export$4f0eff23342a9a3b(seconds) {
    const minutes = Math.floor(seconds / 60);
    return `${String(minutes)}:${String(seconds % 60).padStart(2, "0")}`;
}

});

parcelRegister("hmghX", function(module, exports) {

$parcel$export(module.exports, "postCompleteRegistration", function () { return $d898515f508ef5b9$export$699e04ae1401b953; });
// Best-effort POST to /api/complete-registration (first-login onboarding:
// Slack + Google-name persistence). Shared by the magic-link confirm flow
// (auth-confirm.ts) and the Google OAuth callback (auth-callback.ts). Errors
// are logged, never thrown — onboarding side effects must not block sign-in.
async function $d898515f508ef5b9$export$699e04ae1401b953(accessToken) {
    const controller = new AbortController();
    const timeout = setTimeout(()=>{
        controller.abort();
    }, 8000);
    try {
        await fetch("/api/complete-registration", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken}`
            },
            signal: controller.signal
        });
    } catch (err) {
        console.error("complete-registration failed", err);
    } finally{
        clearTimeout(timeout);
    }
}

});

parcelRegister("8C6MA", function(module, exports) {

$parcel$export(module.exports, "showFormError", function () { return $bfd825a8004fc601$export$5f42f100f752a07c; });
$parcel$export(module.exports, "clearFormError", function () { return $bfd825a8004fc601$export$f96a15e9c4403cf2; });
$parcel$export(module.exports, "showBoxNotice", function () { return $bfd825a8004fc601$export$51d2406237757203; });
/**
 * Inline messages for the static auth pages.
 *
 * These pages are EJS, not the Elm app, so `UI.errorMessage` and the toast
 * system are out of reach and every failure used to reach the user through
 * `alert()` -- which blocks the page, looks like a browser fault rather than
 * part of the product, and carried whatever string the upstream library
 * happened to produce ("Signups not allowed for otp").
 *
 * The wording rule matches the one `api/` handlers already follow (#175 M-1):
 * the detail goes to the console for whoever is debugging, and the user reads
 * something written for them.
 */ /** Styling kept in one place so the three pages cannot drift apart. */ const $bfd825a8004fc601$var$ERROR_CLASSES = [
    "text-sm",
    "rounded-md",
    "px-3",
    "py-2",
    "border-2",
    "text-center",
    "mt-5",
    "text-red-600",
    "border-red-600"
];
function $bfd825a8004fc601$export$5f42f100f752a07c(container, message, detail) {
    if (detail !== undefined) console.error(message, detail);
    $bfd825a8004fc601$export$f96a15e9c4403cf2(container);
    const paragraph = document.createElement("p");
    paragraph.dataset.formError = "true";
    paragraph.setAttribute("role", "alert");
    paragraph.classList.add(...$bfd825a8004fc601$var$ERROR_CLASSES);
    paragraph.textContent = message;
    container.append(paragraph);
}
function $bfd825a8004fc601$export$f96a15e9c4403cf2(container) {
    container.querySelector("[data-form-error]")?.remove();
}
function $bfd825a8004fc601$export$900aa99cc481764f() {
    return [
        ...$bfd825a8004fc601$var$ERROR_CLASSES.filter((c)=>c !== "mt-5"),
        "mb-5"
    ];
}
function $bfd825a8004fc601$export$51d2406237757203(box, message) {
    box.querySelector("[data-box-notice]")?.remove();
    const paragraph = document.createElement("p");
    paragraph.dataset.boxNotice = "true";
    paragraph.setAttribute("role", "alert");
    paragraph.classList.add(...$bfd825a8004fc601$export$900aa99cc481764f());
    paragraph.textContent = message;
    box.prepend(paragraph);
}

});

parcelRegister("5nYF6", function(module, exports) {

$parcel$export(module.exports, "isButtonBusy", function () { return $bd4a3cd4975fa231$export$319e523d0c9bb67f; });
$parcel$export(module.exports, "setButtonBusy", function () { return $bd4a3cd4975fa231$export$e10bc1e590b964f9; });
/**
 * Puts a `.btn` on the static pages into its busy state and back (#387). The
 * markup and its classes are in `button-busy-lib.ts`; the colour rule for a
 * busy button (`.btn[aria-busy="true"]`) is in `styles.css`.
 */ 
var $djLSF = parcelRequire("djLSF");
const $bd4a3cd4975fa231$var$LABEL_ATTRIBUTE = "data-busy-label";
function $bd4a3cd4975fa231$export$319e523d0c9bb67f(button) {
    return button.getAttribute("aria-busy") === "true";
}
function $bd4a3cd4975fa231$export$e10bc1e590b964f9(button, busy) {
    if (busy === $bd4a3cd4975fa231$export$319e523d0c9bb67f(button)) return;
    if (busy) {
        const label = document.createElement("span");
        label.setAttribute($bd4a3cd4975fa231$var$LABEL_ATTRIBUTE, "");
        label.className = (0, $djLSF.HIDDEN_LABEL_CLASS);
        label.append(...Array.from(button.childNodes));
        const overlay = document.createElement("span");
        overlay.className = (0, $djLSF.SPINNER_OVERLAY_CLASS);
        overlay.innerHTML = (0, $djLSF.spinnerSvg)((0, $djLSF.BUTTON_SPINNER));
        button.classList.add("relative");
        button.replaceChildren(label, overlay);
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
    } else {
        const label = button.querySelector(`[${$bd4a3cd4975fa231$var$LABEL_ATTRIBUTE}]`);
        button.replaceChildren(...Array.from(label?.childNodes ?? []));
        button.disabled = false;
        button.setAttribute("aria-busy", "false");
    }
}

});
parcelRegister("djLSF", function(module, exports) {

$parcel$export(module.exports, "BUTTON_SPINNER", function () { return $70cbff2468e54131$export$3fd25a11349a7fac; });
$parcel$export(module.exports, "SPINNER_OVERLAY_CLASS", function () { return $70cbff2468e54131$export$e70ec2ff757eb70e; });
$parcel$export(module.exports, "HIDDEN_LABEL_CLASS", function () { return $70cbff2468e54131$export$b4b59ce58b90eb3e; });
$parcel$export(module.exports, "spinnerSvg", function () { return $70cbff2468e54131$export$aeccd46e13f16e39; });
/**
 * The busy state of a `.btn` on the static pages (#387), drawn exactly like
 * `UI.button` draws it in the app: the label stays in the button, invisible,
 * so the width holds; a spinner sits over it; the button is disabled and
 * `aria-busy`. The DOM half is `button-busy.ts`; what is here is pure, so the
 * markup can be tested against the Elm side's.
 */ /**
 * A spinner as Pencil draws it: `size` in px, `innerRadius` as the ratio of
 * the hole to the outer radius, and the opacity of the track under the arc.
 */ const $70cbff2468e54131$export$3fd25a11349a7fac = {
    size: 20,
    innerRadius: 0.78,
    trackOpacity: 0.25
};
const $70cbff2468e54131$export$510b3f9f24eb2c5 = "block shrink-0 animate-spin motion-reduce:[animation-duration:3s]";
const $70cbff2468e54131$export$e70ec2ff757eb70e = "absolute inset-0 flex items-center justify-center";
const $70cbff2468e54131$export$b4b59ce58b90eb3e = "opacity-0";
/** Two decimals, as `UI.spinner` rounds, so 2.2 is not 2.1999999999999997. */ function $70cbff2468e54131$var$round2(value) {
    return Math.round(value * 100) / 100;
}
function $70cbff2468e54131$export$f1291d07a8f2bcf8(shape) {
    const thickness = $70cbff2468e54131$var$round2(shape.size / 2 * (1 - shape.innerRadius));
    return {
        thickness: thickness,
        radius: $70cbff2468e54131$var$round2(shape.size / 2 - thickness / 2),
        center: shape.size / 2
    };
}
function $70cbff2468e54131$export$aeccd46e13f16e39(shape) {
    const geometry = $70cbff2468e54131$export$f1291d07a8f2bcf8(shape);
    const thickness = String(geometry.thickness);
    const radius = String(geometry.radius);
    const center = String(geometry.center);
    const size = String(shape.size);
    const trackOpacity = String(shape.trackOpacity);
    const ring = `cx="${center}" cy="${center}" r="${radius}" fill="none" stroke="currentColor" stroke-width="${thickness}"`;
    return `<svg viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" class="${$70cbff2468e54131$export$510b3f9f24eb2c5}" aria-hidden="true">` + `<circle ${ring} stroke-opacity="${trackOpacity}"></circle>` + `<circle ${ring} pathLength="360" stroke-dasharray="110 250" transform="rotate(-90 ${center} ${center})"></circle>` + `</svg>`;
}

});




var $5DLox = parcelRequire("5DLox");

var $14CJr = parcelRequire("14CJr");

var $8C6MA = parcelRequire("8C6MA");

var $az6U6 = parcelRequire("az6U6");

var $5nYF6 = parcelRequire("5nYF6");
// MAIN
{
    const dom = $b6189b8edfb82dfd$var$getDomMap();
    const onSubmit = async (event)=>{
        event.preventDefault();
        $b6189b8edfb82dfd$var$disableForm(dom);
        (0, $5nYF6.setButtonBusy)(dom.submitButton, true);
        const email = dom.emailInput.value;
        const { error: error } = await (0, $5DLox.supabase).auth.signInWithOtp({
            email: email,
            options: {
                shouldCreateUser: false
            }
        });
        // The same confirmation whether or not an account exists, which is what
        // /api/register already does: it answers 200 either way so that nobody can
        // test which addresses are registered here. The login form used to answer
        // that question for free, and in an alert carrying GoTrue's own wording
        // ("Signups not allowed for otp") at that.
        //
        // The confirmation panel carries a line for the case this costs us --
        // someone who mistyped their address and is now waiting for a mail that
        // will never arrive.
        // console.info, not error: an address without an account is an expected
        // outcome of this form, not a fault. The trace is here for debugging, and
        // the page says the same thing either way.
        if (error) console.info("magic link not sent", error);
        $b6189b8edfb82dfd$var$showSuccess(dom, email);
    };
    dom.loginForm.addEventListener("submit", (e)=>void onSubmit(e));
    $b6189b8edfb82dfd$var$enableForm(dom);
    // Why the visitor is here, above the headline: the app could not check the
    // session (#442), or the server kept rejecting it (#515). The form stays
    // usable: signing in again tries again.
    const box = document.getElementById("box");
    if (box && (0, $az6U6.arrivedFromUnreachableServer)(window.location.search)) (0, $8C6MA.showBoxNotice)(box, "We couldn't reach the server. Check your connection and try again.");
    else if (box && (0, $az6U6.arrivedAfterSessionEnded)(window.location.search)) (0, $8C6MA.showBoxNotice)(box, "Your session has ended. Please sign in again.");
}function $b6189b8edfb82dfd$var$getDomMap() {
    return {
        loginForm: document.getElementById("loginForm"),
        emailInput: document.getElementById("emailInput"),
        submitButton: document.getElementById("submitButton"),
        success: document.getElementById("success"),
        sentTo: document.getElementById("sentTo"),
        box: document.getElementById("box"),
        otpForm: (0, $14CJr.getOtpFormDom)()
    };
}
function $b6189b8edfb82dfd$var$disableForm(dom) {
    dom.emailInput.disabled = true;
    dom.submitButton.disabled = true;
}
function $b6189b8edfb82dfd$var$enableForm(dom) {
    dom.emailInput.disabled = false;
    dom.submitButton.disabled = false;
}
function $b6189b8edfb82dfd$var$showSuccess(dom, email) {
    // textContent, never innerHTML: this is something a visitor typed.
    dom.sentTo.textContent = email;
    dom.success.classList.remove("invisible");
    dom.success.classList.remove("opacity-0");
    (0, $14CJr.wireOtpCodeForm)({
        dom: dom.otpForm,
        email: email,
        sentAt: Date.now()
    });
}


//# sourceMappingURL=login.99ebc717.js.map
